module.exports = __webpack_public_path__ + "img/null.425a8582.png";